import styles from './styles.module.css';

export const SkeletonHeader = () => {
  return <div className={`${styles.header} ${styles.skeleton}`}></div>;
};

export const SkeletonSmallField = () => {
  return <div className={`${styles.fieldItem} ${styles.skeleton}`}></div>;
};

export const SkeletonBigField = () => {
  return <div className={`${styles.bigFieldItem} ${styles.skeleton}`}></div>;
};

export const SkeletonButton = () => {
  return <div className={`${styles.button} ${styles.skeleton}`}></div>;
};

export const SkeletonFullWidthAndHeight = () => {
  return <div className={`${styles.skeletonFull} ${styles.skeleton}`}></div>;
};

export const SkeletonProductThumbnail = () => {
  return <div className={`${styles.productThumbnail} ${styles.skeleton}`}></div>;
};

type Props = {
  width: number;
  height: number;
  widthSelector?: 'px' | '%';
  heightSelector?: 'px' | '%';
};
export const SkeletonCustom = ({
  width = 100,
  height = 100,
  widthSelector = 'px',
  heightSelector = 'px',
}: Props) => {
  return (
    <div
      className={styles.skeleton}
      style={{
        width: `${width}${widthSelector}`,
        height: `${height}${heightSelector}`,
      }}
    ></div>
  );
};
